// TintiCloud — Métricas / séries temporais determinísticas. Dados de demonstração.

const gen = (n, base, amp, phase) =>
  Array.from({ length: n }, (_, i) => {
    const v = base + amp * Math.sin(i / (n / 6) + phase) + amp * 0.28 * Math.sin(i / 2.3 + phase);
    return Math.max(2, Math.min(98, Math.round(v)));
  });

const labelsFor = (range) => {
  switch (range) {
    case "1h":
      return Array.from({ length: 13 }, (_, i) => `${String(i * 5).padStart(2, "0")}m`);
    case "7d":
      return ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];
    case "30d":
      return Array.from({ length: 15 }, (_, i) => `${i * 2 + 1}`);
    case "24h":
    default:
      return ["00:00", "04:00", "08:00", "12:00", "16:00", "20:00", "24:00"];
  }
};

const buildRange = (range, seed) => {
  const labels = labelsFor(range);
  const n = labels.length;
  const cpu = gen(n, 42, 22, seed);
  const ram = gen(n, 58, 16, seed + 1.2);
  const disk = gen(n, 34, 8, seed + 2.4);
  return labels.map((label, i) => ({ label, cpu: cpu[i], ram: ram[i], disk: disk[i] }));
};

export const infraUsage = {
  "1h": buildRange("1h", 0.4),
  "24h": buildRange("24h", 0.8),
  "7d": buildRange("7d", 1.5),
  "30d": buildRange("30d", 2.1),
};

// Séries por servidor (para Server Detail)
export const serverUsage = (id) => {
  const seed = { sv1: 0.8, sv2: 1.4, sv3: 2.0, sv4: 0.2 }[id] ?? 1;
  return {
    "1h": buildRange("1h", seed),
    "24h": buildRange("24h", seed),
    "7d": buildRange("7d", seed),
    "30d": buildRange("30d", seed),
  };
};

export const dashboardStats = [
  { key: "servers", label: "Servidores", value: "4", icon: "server", accent: true, dots: [{ tone: "ok", label: "3 online" }, { tone: "warn", label: "1 standby" }, { tone: "err", label: "1 erro" }], to: "/servidores" },
  { key: "projects", label: "Projetos", value: "24", icon: "folder", trend: { dir: "up", value: "+3 este mês", tone: "ok" }, to: "/projetos" },
  { key: "containers", label: "Containers", value: "68", icon: "box", dots: [{ tone: "ok", label: "64 ativos" }, { tone: "err", label: "4 parados" }], to: "/containers" },
  { key: "domains", label: "Domínios", value: "31", icon: "globe", dots: [{ tone: "ok", label: "30 com SSL" }, { tone: "err", label: "1 com erro" }], to: "/dominios" },
  { key: "ssl", label: "SSL / Certificados", value: "30", icon: "shield", dots: [{ tone: "warn", label: "1 expira em 14 dias" }], to: "/dominios" },
  { key: "cloudflare", label: "Cloudflare", value: "5", icon: "cloud", dots: [{ tone: "info", label: "Zonas conectadas" }], to: "/cloudflare" },
];
